export const pensionAssets = {
  HEB: {
    header: "ייבוא נכסים פנסיונים",
    description:
      "אנחנו נייבא עבורך מידע עבור כלל הנכסים הפנסיונים שעל שמך מהמסלקה הפנסיונית ונעדכן אותם מידי חודש למשך שנה!",
    description2: {
      part1: "הייבוא הינו",
      bold: "",
      part2: "בעלות חד-פעמית של 47 שקלים",
    },
    description3: {
      part1:
        "על מנת לבצע את הייבוא, נא למלא את הפרטים הבאים:",
      part2: "",
    },
    inputLabels: {
      address: "כתובת",
      city: "עיר",
      street: "רחוב",
      postalCode: "מיקוד",
      houseNumber: "מס' בית",
    },
    multipleMaslulNote: 
    "המידע המתקבל מגיע ישירות מהמסלקה הפנסיונית באמצעות רישיון 027225424 ניתן לצפות בתנאי השימוש שלנו באתר. *לא ניתן לקבל החזר על חלק מהתקופה.",
    clarification: 
    "על מנת לבצע את הייבוא, נא למלא את הפרטים הבאים:",
    confirmation1: "אני מאשר/ת מילוי ושליחה בשמי של טופס",
    linkA: "'נספח א'",
    confirmationA: "כדי שתוכלו לייבא עבורי את הנתונים.",
    moveToPayment: "מעבר לתשלום",
    moveToMasleka: "מעבר למסלקה",

    incompleteAddress:
      "יש למלא את הכתובת המלאה בכדי שנוכל לייבא בשמך את הנכסים שלך.",
    incompleteSignature: "איך נוכל לייבא בשמך ללא חתימתך?",
    missingConfirmationA:
      "אנחנו חייבים אישור של סעיף זה בכדי שנוכל לייבא בשמך את הנכסים שלך.",
    failedPayment: {
      header: "התשלום נכשל",
      list: "נסו אחת מהפעולות הבאות:",
      list1: "1. לנסות לשלם בכרטיס אחר.",
      list2: "2. לבדוק שכל פרטי הכרטיס רשומים בצורה נכונה",
      tryAgain: "נסה שנית",
    },
    paymentNotVerified: {
      header: "האימות נכשל",
      content:
        "התשלום צריך להתבצע עם כרטיס אשראי על שמך בלבד לצורכי אימות. יש לוודא שתעודת הזהות שהוזנה במילוי הפרטים תואמת לתעודת זהות שהזנת בפרטי האשראי.",
      tryAgain: "נסה שנית",
    },
    chargeNotCancel: {
      header: "הבקשה לייבוא מהמסלקה נכשלה",
      content:
        "כדי שהבקשה תישלח בהצלחה התשלום צריך להתבצע עם כרטיס אשראי על שימך בלבד לצורכי אימות, לצערנו לא הצלחנו לבטל את החיוב. יש לפנות לשירות הלקוחות במייל  office@moneytor.co.il לקבלת החזר.",
    },
    successfulPayment: {
      header: "תודה! הפרטים נשלחו בהצלחה.",
      header2: {
        part1: "פרטי התשלום התקבלו בהצלחה",
        bold: "החיוב יתבצע רק בסיום של שליחת הפרטים באתר המסלקה",
        part2: "למעבר לאתר המסלקה למילוי פרטים הקליקו כאן:",
      },
      done: "מעבר לאתר המסלקה",
    },
    successfulMasleka: {
      header: "המסלקה שלך התקבלה בהצלחה",
      header2: {
        part1: "המידע שלך התקבל בהצלחה! הפרטים של הקופות הפנסיוניות שלך צפויים להגיע לאתר תוך 72-3 שעות",
        bold: "החיוב יתבצע כעת",
        part2: "לחזרה לעמוד הנכסים הקליקו על אישור",
      },
      done: "אישור",
    },
    errorMasleka: {
      header: "הייתה בעיה בתהליך ייבוא הנתונים הפנסיוניים",
      header2: {
        part1: "קיבלנו קוד שגיאה בתהליך הייבוא שלך",
        bold: "החיוב יתבטל כעת",
        part2: "ניתן להתחיל את התהליך מחדש על מנת להשלים את הייבוא",
      },
      done: "אישור",
    },
    canceledMasleka: {
      header: "תהליך ייבוא הנתונים הפנסיוניים התבטל באמצע",
      header2: {
        part1: "תהליך ייבוא הנתונים הפנסיוניים לא הושלם כהלכה",
        bold: "החיוב יתבטל כעת",
        part2: "ניתן להתחיל את התהליך מחדש על מנת להשלים את הייבוא",
      },
      done: "אישור",
    },

    maslekaDate: {
      header: "אין סיבה לייבא מחדש",
      description1:
        "שילמתם על עדכון שנתי מתחדש מדי חודש ועדיין לא עברה שנה מאז פעולת הייבוא הקודמת שלכם, לכן אין טעם לחדש את הייבוא עד שיעברו 12 חודשים. הנתונים הפנסיונים ימשיכו להתעדכן לכם באופן חודשי בצורה אוטומטית.",
      description2: "בתאריך",
      description3: "הנתונים יפסיקו להתעדכן וניתן יהיה לחדש את הייבוא",
      done: "הבנתי, תודה",
    },
  },
};
